import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";
import { Store } from "@ngxs/store";
import { Subject, takeUntil } from "rxjs";
import { ConstantsUtil } from "src/app/core/constants/constants.util";
import { EWB_CREATE_COMPONENTS } from "src/app/core/enums/ewbConfiguration.enum";
import { CONFIG_MODE } from "src/app/core/enums/insightConfigurations.enum";
import { AlgorithmList, EwbAlgorithmList, VersionsList } from "src/app/core/models/insight-configuration.model";
import { GetAlgorithmList, GetEWBTimeseries, GetInputId, GetModels, GetVersionsList, SetAlgoLoading, SetSelectedAlgorithm, SetSelectedVersion, UpdateStepValidity } from "src/app/core/store/ewb-configuration/ewb-configuration.action";


@Component({
  selector: 'app-ewb-algorithm',
  templateUrl: './ewb-algorithm.component.html',
  styleUrls: ['./ewb-algorithm.component.scss']
})
export class EwbAlgorithmComponent implements OnInit,OnDestroy {
  @Output() algorithmLoaded: EventEmitter<any> = new EventEmitter<any>();

  public selectedAlgorithm: any;
  public unsubscribe = new Subject<void>();
  public algorithmList: EwbAlgorithmList[];
  public versionsList: VersionsList[];
  public selectedValue = null;
  public selectedVersion = null;
  public algorithmForm: UntypedFormGroup;
  public mode = CONFIG_MODE.CREATE;
  public inputId: string;
  public algorithmId:number;
  public modelList:AlgorithmList[];
  public constants=ConstantsUtil;
  constructor(
    private readonly store: Store,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.mode = this.store.selectSnapshot(state => state.configurations.ewb.mode);
    this.initForm();
    this.store.dispatch(new GetEWBTimeseries());
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  onAlgorithmSelected(event: MatSelectChange): void {
    const selectedAlgorithm = event.value;
    this.selectedValue = selectedAlgorithm;
    this.algorithmId = selectedAlgorithm?.id;
    this.getVersionList(this.algorithmId)
  }

  onVersionSelected(event: MatSelectChange): void {
    const selectedVersion = event.value;
    this.selectedVersion = selectedVersion;
    console.log(this.selectedVersion );
    this.getInputId(this.selectedVersion['id'] );
  }

  public initForm() {
    this.selectedAlgorithm = this.store.selectSnapshot(state => state.configurations.ewb.selectedAlgorithm);
    this.selectedVersion = this.store.selectSnapshot(state => state.configurations.ewb.selectedVersion);
    this.algorithmForm = new UntypedFormGroup({
      algorithm: new UntypedFormControl({ value: this.selectedAlgorithm ? this.selectedAlgorithm : null, disabled: this.mode === CONFIG_MODE.EDIT }, [Validators.required]),
      version: new UntypedFormControl({ value: this.selectedVersion ? this.selectedVersion : null, disabled: this.mode === CONFIG_MODE.EDIT }, [Validators.required])
    })
    this.listenToFormChanges();
    this.AlgorithmListData();
    this.getEwbModels();
    if (this.mode === CONFIG_MODE.EDIT) {
      this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ALGORITHM, true))
    }
  }

  public listenToFormChanges() {

    this.algorithmForm.statusChanges.pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
      if (value === 'VALID') {
        this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ALGORITHM, true))
      } else {
        this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ALGORITHM, false))
      }
    })

    this.algorithmForm.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      const value = this.algorithmForm.getRawValue();
      this.store.dispatch(new SetSelectedAlgorithm(value?.algorithm))
      this.store.dispatch(new SetSelectedVersion(value?.version))

    })
    this.changeDetectorRef.detectChanges();
  }

  public setSelectedAlgorithm(algorithm: any) {
    if (this.algorithmForm) {
      this.algorithmForm?.controls.algorithm.setValue(algorithm);
      this.algorithmForm.controls.algorithm.updateValueAndValidity();
    }
  }
  public setSelectedVersion(version: any) {
    if (this.algorithmForm) {
      this.algorithmForm?.controls.version.setValue(version);
      this.algorithmForm.controls.version.updateValueAndValidity();
    }
  }

  public AlgorithmListData() {
    this.store.dispatch(new SetAlgoLoading(true));
    this.store.select(state => state.configurations.ewb.algorithmList).subscribe(list => {
      this.algorithmList = list;
    });
    let configId = '';
    if (this.mode === CONFIG_MODE.EDIT) {
      configId = this.store.selectSnapshot(state => state.configurations.ewb.configurationDetailsSaved?.categoryId);
    } else {
      configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
    }

    if (this.algorithmList?.length === 0) {
      return this.store.dispatch(new GetModels()).pipe()
        .subscribe(state => {
          this.algorithmList = state.configurations.ewb.algorithmList;
         const firstAlgorithm = this.algorithmList[0];
        this.setSelectedAlgorithm(firstAlgorithm);
        this.getVersionList(firstAlgorithm['id']);
        this.store.dispatch(new SetAlgoLoading(false));
        }
        )
    } else {
       const firstAlgorithm = this.algorithmList[0];
        this.setSelectedAlgorithm(firstAlgorithm);
        this.getVersionList(firstAlgorithm['id']);

      this.store.dispatch(new SetAlgoLoading(false))
    }
  }

  public getVersionList(algorithmId: any) {
    this.store.select(state => state.configurations.ewb.versionsList).subscribe(list => {
      this.versionsList = list;
      console.log(this.versionsList)
    });
    let configId = '';
    if (this.mode === CONFIG_MODE.EDIT) {
      configId = this.store.selectSnapshot(state => state.configurations.ewb.configurationDetailsSaved?.categoryId);
    } else {
      configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
    }

    return this.store.dispatch(new GetVersionsList(algorithmId)).pipe()
      .subscribe(state => {
        this.versionsList = state.configurations.ewb.versionsList;
        console.log(this.versionsList)
        this.setSelectedVersion(this.versionsList[0]);
        this.store.dispatch(new SetAlgoLoading(false));
         this.getInputId(this.versionsList[0]['id'])
      }
      )
  }

  public getEwbModels() {
      this.store.dispatch(new SetAlgoLoading(true));
      this.modelList = this.store.selectSnapshot(state => state.configurations.ewb.modelList);
      let configId = '';
      if(this.mode === CONFIG_MODE.EDIT){
        configId = this.store.selectSnapshot(state => state.configurations.ewb.configurationDetailsSaved?.categoryId);
      }else{
        configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
      }
  
      if(this.modelList.length === 0) {
        return this.store.dispatch(new GetAlgorithmList(configId)).pipe()
        .subscribe(state => {
            this.modelList = state.configurations.ewb.modelList;
           // this.setSelectedAlgorithm(this.algorithmList[0]);
            this.store.dispatch(new SetAlgoLoading(false));
          }
        )
      }
    }
  

  public getInputId(id:any) {
    this.store.dispatch(new GetInputId(id)).pipe()
      .subscribe(state => {
        this.inputId = state.configurations.ewb.inputId;
        console.log('id' + this.inputId)
      })
  }


  get CONFIG_MODE() {
    return CONFIG_MODE;
  }
}
